angular.module('impactx.panel').directive('ixSupplierPanel', function () {
    return {
        restrict: 'E',
        scope: {
            id: '=id',
            type: '@',
            image: '=',
            name: '@',
            description: '@',
            destination: '@',
            supplier: '=',
            withAdditionalInfo: '=',
            outletHeader: "@",
            outletsInfoHeader: "@",
            conditionsHeader: "@",
            cancelHeader: "@",
            infoHeader: "@",
            trns: '=',
            currentFilter: "="
        },
        controller: 'SupplierPanelCtrl',
        controllerAs: 'panelCtrl',
        templateUrl: 'shared/panel/templates/supplier.panel.tmpl.html',
        link: function (scope) {
            scope.backupImage = "img/missing-image.jpg";
        }
    }
});